import {fillInput} from "../functions";
import {createSlice} from "@reduxjs/toolkit";
import {prefixUrl} from "../../../utils/utilsData";
import _axios from "../../../httpService";
import tableCalc from "../../../utils/tableCalc";
import {toast} from "react-toastify";

export const initialSendData = {
  mode: "add",
  documentPageData: {
    accounts: [],
    headerAndFooter: [],
    id: [],
  },
  documentCode: "",
  documentDescription: "",
  documentDate: "",
  documentTime: "",
  groupId: "",
  tableData: [
    {
      uniqId: "0",
      indexRow: "",
      accountCode: "",
      value: "",
      accountTitle: "",
      description: "",
      floatingAccount: "",
      floatingAccountCode: "",
      floatingAccountTitle: "",
      hasSubAccount:false,
      bed: "",
      bes: "",
      level1Code: "",
      level1Name: "",
      level2Code: "",
      level2Name: "",
      level3Code: "",
      level3Name: "",
      level4Code: "",
      level4Name: "",
      level4FloatingCode: "",
    },
  ],
  chartDataUnderTable: {
    totalWidth: 300,
    bedWidth: 100,
    besWidth: 200,
    isShow: true,
  },

  remainToBalance: 100,
  sumOfBed: 0,
  sumOfBes: 0,


}

//reviewAccountsReducers
const submitDocumentFormReducer = {
  fillInput,

  // timePeriodChanger: (state, action) => {
  //   state.timePeriod = action.payload.timePeriod
  // }

}

export const getDocumentPageData = () => {
  return async (dispatch) => {
    try {
      const result = await _axios
        .get(prefixUrl() + "/accountingDocument/?request=documentPageData")


      if (result.data) {
        dispatch(submitDocumentFormAction.fillInput({documentPageData: result.data}))

      }
    } catch (error) {
      console.log(error)
    }
  }

}


export const submitDocumentFormSlice = createSlice({
  name: 'submitDocumentFormReducer',
  initialState: initialSendData,
  reducers: submitDocumentFormReducer
});


export const requestTableDataReview000 = (
  {
    level = 0,
    prevLevel = '',
    accountCode = "",
    mode = 'overall',
    passedLevels = [],
    passedAccounts = [],
    downToUpType = 0,
    path = [],
    filters
  }
) => {


  const dddd = {
    accountCode,
    prevLevel,
    level,
    mode,
    passedAccounts,
    passedLevels,
  }
  localStorage.setItem("lastRequestPayload", JSON.stringify(dddd))

  path = JSON.stringify(path)
  passedLevels = JSON.stringify(passedLevels)
  passedAccounts = JSON.stringify(passedAccounts)

  return async (dispatch) => {


    const url = prefixUrl() + "/accountingTreeChart/" + `?request=accountTransactions&prevLevel=${prevLevel}&level=${level}&accountCode=${accountCode}&mode=${mode}&downToUpType=${downToUpType}&passedLevels=${passedLevels}&passedAccounts=${passedAccounts}&path=${path}&filter=${filters}`


    const run = async () => {
      try {
        const response = await _axios.get(url);

        if (response.data.status) {
          const myData = Object.assign({}, response.data.data)
          myData.data = myData.data.map(v => {
            v.currentLevel = response.data.data.currentLevel
            v.mainCurrentLevel = response.data.data.mainCurrentLevel
            return v;
          })


          const column = myData.column;

          const isOverAll = response.data.data.isOverall;
          column.forEach(v => {
            if (response.data?.data?.priceFields.includes(v.field)) v.bottomCalc = "sum"
          })
          if (isOverAll) {
            column.forEach(v => {
              v.style = {
                display: 'flex', justifyContent: 'center', alignItem: 'center'
              }

            })

          } else {
            // column.forEach(v => {
            //   v.style = {
            //     display: 'flex',
            //     justifyContent: 'center',
            //     alignItem: 'center'
            //   }
            // })
          }

          if (response.data?.data?.priceFields?.length > 0) {
            const priceFields = [...response.data?.data?.priceFields]
            tableCalc.addSeparator(column, priceFields)
          }


        } else {
          // dispatch(fillInput({receivedData: response.data.data}))
          toast.error(response?.data?.message)
        }
      } catch (error) {
        console.log(error)
      }
    }

    const result = run()
    await toast.promise(result, {
      pending: "در حال دریافت اطلاعات", // success: "اطلاعات دریافت شد.",
      //error: "",
    });
  }
}

export const submitDocumentFormAction = submitDocumentFormSlice.actions
export default submitDocumentFormSlice.reducer